export default __webpack_public_path__ + "img/tab2s-15aacc06.png";